import React from 'react';
import { ArticleCard } from './ArticleCard';
export function BottomArticles() {
  const articles = [{
    title: 'Sysco makes $29 billion deal to acquire Restaurant Depot',
    category: 'Companies',
    date: '04.07.2026',
    author: 'Ryan McCarthy',
    imageUrl: 'https://placehold.co/400x300/e2e8f0/475569?text=Sysco+Truck'
  }, {
    title: 'Registration opens for World Pork Expo 2026',
    category: 'Associations',
    date: '04.07.2026',
    author: 'Rachael Oatman',
    imageUrl: 'https://placehold.co/400x300/e2e8f0/475569?text=Expo+Crowd'
  }, {
    title: 'Tyson promotes chief accounting officer',
    category: 'Companies',
    date: '04.06.2026',
    author: 'Ryan McCarthy',
    imageUrl: 'https://placehold.co/400x300/e2e8f0/475569?text=Tyson+Foods'
  }];
  return <section className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-36" data-mp="7hs7d7q0wemp">
      {articles.map((article, index) => <ArticleCard key={index} {...article} imageClassName="w-28 h-20" data-id="element-37" data-mp="2jgyaz7jy85j" data-mpi={index} />)}
    </section>;
}